
  import { Component, Vue,Inject } from 'vue-property-decorator';
  import Footer from '../components/Footer.vue'
  import TenantSwitch from '../components/tenant-switch.vue'
  import LanguageSwitch from '../components/language-switch.vue'
  import AbpBase from '../lib/abpbase'
  import apidoc from '@/views/setting/apidoc/apidoc.vue';
  @Component({
   components:{apidoc}
  })
  export default class Login extends AbpBase {
   loginModel={
     userNameOrEmailAddress:'',
     password:'',
     rememberMe:false,
     userType:1,
     googleCode:''
   }
   
   created(){
   }
  }
  